import { ReactElement, useEffect } from 'react';
import * as React from 'react';

import styles from './boost-checkbox-group.module.scss';
import { Checkbox } from '@utmb/design-system/checkbox/Checkbox';
import { useTranslation } from 'next-i18next';

interface BoostCheckboxGroupeProps {
    callback: (value: boolean) => void;
}

export const BoostCheckboxGroup = ({ callback }: BoostCheckboxGroupeProps): ReactElement => {
    const { t } = useTranslation();
    const [rule1, setRule1] = React.useState<boolean>(false);
    const [rule2, setRule2] = React.useState<boolean>(false);
    const [rule3, setRule3] = React.useState<boolean>(false);

    useEffect(() => {
        if (rule1 && rule2 && rule3) {
            callback(true);
        } else {
            callback(false);
        }
    }, [rule1, rule2, rule3]);

    return (
        <div className={styles.boostCheckboxGroup}>
            <Checkbox
                className={styles.checkbox}
                id="rule1"
                name="rule1"
                label={t('races.preregistration.boostPopin.rule1')}
                checked={rule1}
                onClick={() => setRule1(!rule1)}
            />
            <Checkbox
                className={styles.checkbox}
                id="rule2"
                name="rule2"
                label={t('races.preregistration.boostPopin.rule2')}
                checked={rule2}
                onClick={() => setRule2(!rule2)}
            />
            <Checkbox
                className={styles.checkbox}
                id="rule3"
                name="rule3"
                label={t('races.preregistration.boostPopin.rule3')}
                checked={rule3}
                onClick={() => setRule3(!rule3)}
            />
        </div>
    );
};
